// extracted by mini-css-extract-plugin
export default {"PostMenuTrigger":"pz_a bii_i bii_j bii_q bii_vt bii_xl bii_et"};